function mnrInitReveals() {
  var els = document.querySelectorAll('.mnr-reveal:not(.mnr-observed)');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    els.forEach(function (el) { el.classList.add('mnr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mnr-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) {
    el.classList.add('mnr-observed');
    observer.observe(el);
  });
}

function mnrInitCountUp() {
  var els = document.querySelectorAll('.mnr-countup:not(.mnr-counted)');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('mnr-counted');
        observer.unobserve(el);
        var target = parseFloat(el.dataset.target || '0');
        var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
        var suffix = el.dataset.suffix || '';
        if (reduced) {
          el.textContent = target.toFixed(decimals) + suffix;
          return;
        }
        var duration = 1600;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mnrInitComparador() {
  var roots = document.querySelectorAll('[data-mnr-comparador]:not(.mnr-comparador-init)');
  roots.forEach(function (root) {
    root.classList.add('mnr-comparador-init');
    var antes = root.querySelector('[data-mnr-antes]');
    var handle = root.querySelector('[data-mnr-handle]');
    var dragging = false;

    function setPercent(percent) {
      percent = Math.min(100, Math.max(0, percent));
      antes.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
      root.setAttribute('aria-valuenow', Math.round(percent));
    }

    function percentFromEvent(clientX) {
      var rect = root.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      root.setPointerCapture(e.pointerId);
      setPercent(percentFromEvent(e.clientX));
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPercent(percentFromEvent(e.clientX));
    });
    root.addEventListener('pointerup', function () { dragging = false; });
    root.addEventListener('pointercancel', function () { dragging = false; });
    root.addEventListener('keydown', function (e) {
      var current = parseFloat(root.getAttribute('aria-valuenow') || '50');
      if (e.key === 'ArrowLeft') setPercent(current - 5);
      if (e.key === 'ArrowRight') setPercent(current + 5);
    });

    setPercent(50);
  });
}

function mnrInitProductoSecundario() {
  var root = document.querySelector('[data-mnr-producto-secundario]');
  if (!root) return;
  var form = root.querySelector('form');
  if (!form) return;
  var priceEl = root.querySelector('[data-mnr-precio]');
  var idInput = form.querySelector('input[name="id"]');
  var options = root.querySelectorAll('[data-mnr-variante]');
  options.forEach(function (btn) {
    btn.addEventListener('click', function () {
      options.forEach(function (b) { b.classList.remove('mnr-activa'); });
      btn.classList.add('mnr-activa');
      if (idInput) idInput.value = btn.dataset.variantId;
      if (priceEl) priceEl.textContent = btn.dataset.variantPrice;
    });
  });
}

function mnrInitAll() {
  mnrInitReveals();
  mnrInitCountUp();
  mnrInitComparador();
  mnrInitProductoSecundario();
}

document.addEventListener('DOMContentLoaded', mnrInitAll);
document.addEventListener('shopify:section:load', mnrInitAll);
